import { getServerURL } from 'src/modules/debug/utils';
export const uploadURL = `${getServerURL()}/file/upload`;
